import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ApsServiceService } from '../aps-service.service';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css']
})
export class PaymentsComponent implements OnInit {
  loaderdata:any=true;
  checkpaymentstatus: any;
  paymenterror: boolean;
  loaderpaymet:any=true;

  constructor(private activatedRoute: ActivatedRoute,   private searchitem: ApsServiceService,
    ) { }

  ngOnInit(): void {
    this.getparams()

  }


  // cancel?token=EC-08H364771S512774X


  getparams(){
    if(localStorage.getItem("shoppaymets")){
    this.checkpaymentstatus = this.activatedRoute.snapshot.params.payment;
    //console.log(this.activatedRoute.snapshot.params)
    console.log(this.checkpaymentstatus)
    if(this.checkpaymentstatus=="success"){
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      //console.log(params);
      
      var itemss=parseFloat(localStorage.getItem("totalCart"));
var payments={
  "currency": "USD",
  "total": itemss
}


var storedata=localStorage.getItem("storedcart")

this.searchitem.paymentSuccess(payments,params,storedata).subscribe((responce) => {
  if(responce.status){
 
    localStorage.removeItem("shoppaymets");
    var packageplace=localStorage.getItem("productplace")
    localStorage.removeItem('key');

    localStorage.removeItem('totalCart');
    //console.log(responce)
    //console.log(responce.data.payer.payer_info)
    //console.log(responce.data.transactions[0].item_list.items)


    this.searchitem.paymentInsert(responce.data.payer.payer_info,responce.data.transactions[0].item_list.items,payments,packageplace).subscribe((responce) => {
      if(responce.status){
        this.loaderpaymet=false
        this.loaderdata=false;
        this.paymenterror=true
      }else{
        this.loaderpaymet=false
        this.loaderdata=false;
        this.paymenterror=true
      }

    })
    

    // this.data=responce.data
    // this.eventdetails= this.sanitizer.bypassSecurityTrustHtml(responce.data[0].event_details

}

})
      
    });



  }else     if(this.checkpaymentstatus=="cancel"){
    this.loaderdata=false;
    this.loaderpaymet=false
    console.log("cancel working")
    localStorage.removeItem("shoppaymets");
  }

}else{
  localStorage.removeItem("shoppaymets");
  this.loaderdata=false;
  this.loaderpaymet=false
  console.log("else cancel working")


}

  }
}
